import { canUseDOM } from '@surfline/web-common';

const canUseAnalytics = !!((canUseDOM && window.analytics && window.analytics.user));

export default function (identity, sourceOrigin = null) {
  const { id: anonymousId, type, userId } = identity;
  if (canUseAnalytics) {
    window.analytics.user().anonymousId(anonymousId);
    if (type === 'logged_in') {
      window.analytics.identify(userId, { sourceOrigin });
    }
  }
}
